export const LANGUAGE_LOCAL_STORAGE_KEY = 'i18nextLng'

export const SPANISH = 'es'
